import { render } from "./NotaRemisionForm.vue?vue&type=template&id=550a473c&scoped=true"
import script from "./NotaRemisionForm.vue?vue&type=script&lang=js"
export * from "./NotaRemisionForm.vue?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=550a473c&scoped=true&lang=css&external"
import "./NotaRemisionForm.vue?vue&type=style&index=1&id=550a473c&media=print&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550a473c"]])

export default __exports__